export const ASSESSMENT_MIME_TYPES = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
export const ASSESSMENT_EXTENSIONS = ['.pdf', '.doc', '.docx'];
export const ASSESSMENT_MAX_SIZE = 500 * 1024 * 1024;
